import axios from "axios";
import { refreshTokenAPI } from "./apis/auth";
import { updateToken, deAuthenticate } from "../store/reducers/authSlice";
import { clearPersistedData } from "../store/configureStore";

let refreshTimer = null;

// Token refresh interval: 55 minutes (in milliseconds)
const REFRESH_INTERVAL = 55 * 60 * 1000;

// const REFRESH_INTERVAL = 1 * 60 * 1000; 

export const startTokenRefresh = (dispatch, refreshToken, rememberMe) => {
  // Clear any existing timer
  stopTokenRefresh();

  // Only start timer if Remember Me is checked
  if (!rememberMe || !refreshToken) {
    return;
  }

  refreshTimer = setTimeout(async () => {
    try {
      const response = await refreshTokenAPI(refreshToken);
      
      if (response.status === 200) {
        // Update tokens in Redux
        dispatch(updateToken({
          idToken: response.data.idToken,
          refreshToken: response.data.refreshToken
        }));

        // Update axios default headers with new token
        axios.defaults.headers.common['Authorization'] = `Bearer ${response.data.idToken}`;

        // Start next refresh cycle
        startTokenRefresh(dispatch, response.data.refreshToken, rememberMe);
      }
    } catch (error) {
      console.error("Token refresh failed:", error);
      // If refresh fails, log out the user
      dispatch(deAuthenticate());
      clearPersistedData();
    }
  }, REFRESH_INTERVAL);
};

export const stopTokenRefresh = () => {
  if (refreshTimer) {
    clearTimeout(refreshTimer);
    refreshTimer = null;
  }
};
